import { Box, type BoxProps } from "@mui/material";
import {
	type PropsWithChildren,
	useLayoutEffect,
	useRef,
	useState,
} from "react";
import { useBottomBarSpacing } from "web_myplann/Shared/Hooks/useBottomBarSpacing";

type Props = Omit<BoxProps<"footer">, "children" | "component" | "ref">;

export const FixedFooter = ({
	children,
	sx,
	...footerProps
}: PropsWithChildren<Props>) => {
	const bottomBarSpacing = useBottomBarSpacing();
	const footerRef = useRef<HTMLElement>(null);
	const [footerHeight, setFooterHeight] = useState(0);

	useLayoutEffect(() => {
		const element = footerRef.current;
		if (!element) return;

		const updateHeight = () => setFooterHeight(element.offsetHeight);
		updateHeight();

		const observer = new ResizeObserver(updateHeight);
		observer.observe(element);
		return () => observer.disconnect();
	}, []);

	return (
		<>
			<Box aria-hidden height={`${footerHeight}px`} />
			<Box
				ref={footerRef}
				component="footer"
				position="fixed"
				bottom={bottomBarSpacing ?? 0}
				left={0}
				right={0}
				px={1.6}
				pb={1.6}
				{...footerProps}
				sx={sx}
			>
				{children}
			</Box>
		</>
	);
};
